import React, { useState, useEffect } from 'react'
import FormModal from '../../components/modals/FormModal'
import Spiner from '../../components/modals/Spiner'
import userLogic from '../../functions/logic/userLogic'
import { useSnackbar } from 'notistack'
import '../../scss/EnvioFacturacion.scss'

export default function EnvioFacturacion() {
  const { enqueueSnackbar } = useSnackbar()
  const [showModal, setShowModal] = useState(false)
  const [spiner, setSpiner] = useState(false)
  const [tittle, setTittle] = useState('')
  const [defaultAddress, setDefaultAddress] = useState([])
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [activeTab, setActiveTab] = useState('tab-9')

  useEffect(() => {
    setSpiner(true)
    setActiveTab('tab-9')
    getAddress()
    setSpiner(false)
  }, [])

  const getAddress = async () => {
    const address = await userLogic.getAddressLogic(0, '')

    if (address.success && address.data.length > 0) {
      const sortedAddresses = address.data.sort((a, b) =>
        b.es_principal.localeCompare(a.es_principal)
      )

      setDefaultAddress(sortedAddresses)
    }
  }

  const handleModalClose = () => {
    setShowModal(false)
    setSelectedAddress(null)
  }

  const handleModalShow = (address) => {
    setSpiner(true)
    setTittle('Actualizar dirección de envío')
    setSelectedAddress(address)
    setShowModal(true)
    setSpiner(false)
  }

  const handledSaveParam = async (event) => {
    setSpiner(true)
    event.preventDefault()

    const response = await userLogic.saveAddressLogic(event.target)

    enqueueSnackbar(response.message, {
      variant: response.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })

    if (response.success) {
      setShowModal(false)
      window.location.reload()
    }

    setSpiner(false)
  }

  const togglePrincipal = async (id) => {
    const updatedAddresses = defaultAddress.map((address) => ({
      ...address,
      es_principal: address.id === id ? 't' : 'f'
    }))

    const sortedAddresses = updatedAddresses.sort((a, b) =>
      b.es_principal.localeCompare(a.es_principal)
    )

    setDefaultAddress(sortedAddresses)

    const selectedAddress = defaultAddress.find((address) => address.id === id)

    setSpiner(true)

    const response = await userLogic.savePrincipalLogic(selectedAddress)

    enqueueSnackbar(response.message, {
      variant: response.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })

    if (response.success) {
      setShowModal(false)
      window.location.reload()
    }

    setSpiner(false)
  }

  const hasAddresses = defaultAddress.length > 0

  return (
    <>
      <Spiner opt={spiner} />

      <FormModal
        isOpen={showModal}
        handleCloseModal={handleModalClose}
        header={tittle}
        button="Guardar"
        formData={selectedAddress || {}}
        handledSave={handledSaveParam}
        opt="addressInvoice"
      />

      <nav aria-label="breadcrumb" className="breadcrumb-nav mb-2">
        <div className="container">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">Usuario</li>
            <li className="breadcrumb-item active">Direcciones</li>
          </ol>
        </div>
      </nav>

      <div className="page-content shipping-page">
        <div className="container">
          <div className="shipping-container">
            <div className="shipping-header">
              <div>
                <h2>Mis direcciones</h2>
                <p>Administra tus direcciones de envío y facturación</p>
              </div>

              <button
                className="shipping-add-btn"
                onClick={() => handleModalShow({})}
              >
                <span>+</span>
                Agregar dirección
              </button>
            </div>

            <div
              className={`tab-pane fade ${
                activeTab === 'tab-9' ? 'show active' : ''
              }`}
              id="tab-9"
              role="tabpanel"
              aria-labelledby="tab-9-tab"
            >
              <div className="addresses">
                {hasAddresses ? (
                  <div className="row">
                    {defaultAddress.map((address) => (
                      <div key={address.id} className="col-lg-6 col-md-6 mb-4">
                        <div
                          className={`shipping-address-card ${
                            address.es_principal === 't' ? 'is-primary' : ''
                          }`}
                        >
                          <div className="address-card-header">
                            <div className="address-icon">
                              <i className="icon-map-marker"></i>
                            </div>

                            <div className="address-title">
                              <h3>Dirección de envío</h3>
                              <span>
                                {address.canton_name}, {address.provincia_name}
                              </span>
                            </div>

                            {address.es_principal === 't' && (
                              <span className="principal-badge">Principal</span>
                            )}
                          </div>

                          <div className="address-divider"></div>

                          <div className="address-details">
                            <div className="address-detail">
                              <span>Nombre</span>
                              <strong>{address.nombres}</strong>
                            </div>

                            <div className="address-detail">
                              <span>Teléfono</span>
                              <strong>{address.telefono_contacto}</strong>
                            </div>

                            <div className="address-detail address-full">
                              <span>Dirección</span>
                              <strong>{address.direccion}</strong>
                            </div>

                            <div className="address-row">
                              <div className="address-detail">
                                <span>Ciudad</span>
                                <strong>{address.canton_name}</strong>
                              </div>

                              <div className="address-detail">
                                <span>Código postal</span>
                                <strong>{address.codigo_postal}</strong>
                              </div>
                            </div>
                          </div>

                          <div className="address-actions">
                            <label className="principal-selector">
                              <input
                                type="checkbox"
                                checked={address.es_principal === 't'}
                                onChange={() => togglePrincipal(address.id)}
                              />
                              <span>Usar como dirección principal</span>
                            </label>

                            <button
                              className="shipping-edit-btn"
                              onClick={() => handleModalShow(address)}
                            >
                              <i className="icon-edit"></i>
                              Editar
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="empty-addresses">
                    <div className="empty-address-icon">
                      <i className="icon-map-marker"></i>
                    </div>

                    <h3>No tienes direcciones guardadas</h3>

                    <p>
                      Agrega una dirección para utilizarla durante tus compras.
                    </p>

                    <button
                      className="shipping-add-btn"
                      onClick={() => handleModalShow({})}
                    >
                      <span>+</span>
                      Agregar dirección
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
